// extracted by mini-css-extract-plugin
export var actionButton = "_p5-0";
export var actionMenuContainer = "_p5-i";
export var bubble = "_p5-2";
export var bubbleActionMenu = "_p5-j";
export var bubbleContext = "_p5-6";
export var bubbleItems = "_p5-7";
export var customer = "_p5-3";
export var divider = "_p5-8";
export var fileList = "_p5-9";
export var hiddenComment = "_p5-o";
export var infoAbove = "_p5-a";
export var internal = "_p5-4";
export var lightActionButton = "_p5-1";
export var link = "_p5-b";
export var merchant = "_p5-5";
export var message = "_p5-c";
export var profilePicture = "_p5-e";
export var quillToolbarContainer = "_p5-f";
export var senderDate = "_p5-g";
export var senderDateCustomer = "_p5-h";
export var senderName = "_p5-d";
export var time = "_p5-k";
export var uploadedImage = "_p5-l";
export var username = "_p5-m";
export var xsmall = "_p5-n";